/**
 * Emoji prefixes for public Link in Bio secondary rows (by `type` from config).
 * Keeps custom label text; only prepends when missing a leading emoji.
 */
const SECONDARY_TYPE_EMOJI = {
  menu: "📜",
  website: "🌐",
  call: "📞",
  location: "📍",
};

/** True if string starts with an emoji (avoids double-prefix). */
function startsWithEmoji(s) {
  if (!s) return false;
  try {
    return /^\p{Extended_Pictographic}/u.test(s);
  } catch {
    return false;
  }
}

/**
 * @param {string} [type]
 * @param {string} [label]
 * @returns {string}
 */
export function decorateSecondaryLabelForPublic(type, label) {
  const s = String(label || "").trim();
  if (!s) {
    return s;
  }
  if (startsWithEmoji(s)) {
    return s;
  }
  const key = String(type || "website").toLowerCase();
  const emoji = SECONDARY_TYPE_EMOJI[key] || "🔗";
  return `${emoji} ${s}`;
}
